import Image from "next/image";
import React from "react";
import striptags from "striptags";

const IndustrySolutions = ({ industryData }) => {
  const titleWithoutPTag = industryData?.value?.title;
  return (
    <section className="industries-solutions-section">
      <div className="industries-solutions-inner">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="section-heading">
                <span
                  itemProp="heading"
                  dangerouslySetInnerHTML={{
                    __html: titleWithoutPTag,
                  }}
                ></span>
                <p
                  itemProp="description"
                  dangerouslySetInnerHTML={{
                    __html: industryData?.value?.description,
                  }}
                ></p>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="industries-solutions-list">
                {industryData?.value?.list?.map((val, i) => {
                  return (
                    <div className="icon-horizontal-card" key={i}>
                      <div className="horizontal-card-icon">
                        {val?.value?.image?.url && (
                          <Image
                            height={100}
                            width={100}
                            src={val?.value?.image?.url}
                            alt={val?.value?.image?.alt_text ?? 'Requirement Gathering'}
                            loading="eager"
                          />
                        )}
                      </div>
                      <div className="horizontal-card-content">
                        <span
                          className="heading-h4 horizontal-card-title"
                          dangerouslySetInnerHTML={{
                            __html: val?.value?.title,
                          }}
                        ></span>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: val?.value?.description,
                          }}
                        ></p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustrySolutions;
